$(document).ready(function(){
let fileInput = document.getElementById("file");
let image = document.getElementById("image");
let downloadButton = document.getElementById("download");
let aspectRatio = document.querySelectorAll(".aspect-ratio-button");
const previewButton = document.getElementById("preview");
const flipButton = document.getElementById("flip");
const previewImage = document.getElementById("preview-image");
const options = document.querySelector(".options");
const widthInput = document.getElementById("width-input");
const heightInput = document.getElementById("height-input");
let msginstuctor = document.querySelector(".crop-instruction-msg");
let previewinstructor = document.querySelector(".flipcrop-instruction-msg");
let previewImgwrapper = document.querySelector(".preview-container");
let imageContainer = document.querySelector(".image-container")
let cropper = "";
let fileName = "";

fileInput.onchange = () => {
  previewImage.src = "";
  heightInput.value = 0;
  widthInput.value = 0;
  downloadButton.classList.add("hide");
  msginstuctor.classList.add("hide");
  //The FileReader object helps to read contents of file stored on the computer
  let reader = new FileReader();
  //readAsDataURL reads the content of input file
  reader.readAsDataURL(fileInput.files[0]);

  reader.onload = () => {
    image.setAttribute("src", reader.result);
    if (cropper) {
      cropper.destroy();
    }
    //Initialize cropper
    cropper = new Cropper(image);
    imageContainer.classList.remove("hide");
    options.classList.remove("hide");
    previewButton.classList.remove("hide");
    flipButton.classList.remove("hide");
    previewinstructor.classList.remove("hide");
    previewImgwrapper.classList.add("hide");
  };
  fileName = fileInput.files[0].name.split(".")[0];
};

//Set aspect ration
aspectRatio.forEach((element) => {
  element.addEventListener("click", () => {
    if (element.innerText == "Free") {
      cropper.setAspectRatio(NaN);
    } else {
      cropper.setAspectRatio(eval(element.innerText.replace(":", "/")));
    }
  });
});

heightInput.addEventListener("input", () => {
  const { height } = cropper.getImageData();
  if (parseInt(heightInput.value) > Math.round(height)) {
    heightInput.value = Math.round(height);
  }
  let newHeight = parseInt(heightInput.value);
  cropper.setCropBoxData({ height: newHeight });
});
widthInput.addEventListener("input", () => {
  const { width } = cropper.getImageData();
  if (parseInt(widthInput.value) > Math.round(width)) {
    widthInput.value = Math.round(width);
  }
  let newWidth = parseInt(widthInput.value);
  cropper.setCropBoxData({ width: newWidth });
});

previewButton.addEventListener("click", (e) => {
  e.preventDefault();  
  downloadButton.classList.remove("hide");
  msginstuctor.classList.remove("hide");
  previewImgwrapper.classList.remove("hide");
  previewinstructor.classList.add("hide");
 
  let imgSrc = cropper.getCroppedCanvas({}).toDataURL();
  //Set preview
  previewImage.src = imgSrc;
  downloadButton.download = `cropped_${fileName}.png`;
  downloadButton.setAttribute("href", imgSrc);
});

// flipButton.addEventListener("click", (e) => {
 
//    e.target[0].classList.toggle('flipped');
//   // $(this).toggleClass("flipped");
//   //  if($(this).hasClass("flipped")){   
//   //  cropper.scaleX(-1);
//   //  }
//   // else{
//   //   cropper.scaleX(1);
//   // }
// });

$("#flip").on('click', function(){
  $(this).toggleClass("flipped");
  if($(this).hasClass("flipped")){   
    cropper.scaleX(-1);
  }
  else{
    cropper.scaleX(1);
  }
});

window.onload = () => {
  download.classList.add("hide");
  options.classList.add("hide");
  previewButton.classList.add("hide");
  flipButton.classList.add("hide");
};


 
});